/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/sparkline.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'The values representing the y-axis values of a sparkline graph for a given aggregation over a period of time.',
  examples: [
    'FROM employees\n| STATS sparkline = SPARKLINE(COUNT(*), hire_date, 20, "1985-01-01T00:00:00Z", "1985-12-31T00:00:00Z")',
  ],
  params: {
    aggregation: 'Aggregation that calculates the y-axis value of the sparkline graph for each datapoint.',
    key: 'Date expression from which to derive buckets.',
    buckets: 'Target number of buckets.',
    from: 'Start of the range. Can be a date or a date expressed as a string.',
    to: 'End of the range. Can be a date or a date expressed as a string.',
  },
};

export default docs;
